import { useMediaQuery } from '@mantine/hooks';
import { useDownloadContract } from 'hooks/useDownloadContract';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGetEmployedQuery } from 'redux/Api/employedsApi/employedsApi';
import { StatusProfileContent } from './StatusProfileContent';
import { ContractsProfileContent } from './ContractsProfileContent';
import { ReferencesProfileContent } from './ReferencesProfileContent';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { Helmet } from 'react-helmet';
import styles from './EmployedsProfileContent.module.scss';
import { Link } from 'react-router-dom';
import { ReactComponent as BackBtn } from './img/iconChewronForward.svg';
import { Avatar } from 'components/Avatar';
import { TabMenu } from 'components/TabMenu';
import { Button } from 'ui/Button';
import { ReactComponent as IconPlus } from './img/iconPlus.svg';
import { ReactComponent as DownloadWhite } from './img/downloadWhite.svg';
import { Modal } from 'components/Modal';
import { CreateContractForm } from 'components/CreateContractForm';
import { ModalConfirm } from 'components/ContractItem/ModalConfirm';
import { getProblem } from './GetProblem';
import { CreateDownloadReferenceHandler } from './createDownloadReferenceHandler';
import { Loader } from '@mantine/core';
import { CreateEmployedsСategory } from '../../components/CreateEmployedsСategory';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';
import { getFullName } from 'utils/strActions';
import { WORKER_PROFILE_MODAL_MESSAGES } from 'constants/workerProfileMessages';
import { getErrorCreateContractMessage, tabs } from './constants';
import { getFormatPhone } from 'utils/getFotmatPhone';

export const EmployedsProfileContentDesktop = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data: worker,
    isLoading,
    error,
    refetch,
  } = useGetEmployedQuery({ id: Number(id) });
  const [isLoadingReference, setIsLoadingReference] = useState(false);
  const [referencesRefetch, setReferencesRefetch] = useState<(() => void) | null>(null);
  const [isLoadingDownloading, setIsLoadingDownloading] = useState(false);
  const [contractData, setContractData] = useState<{ id: number; number: string } | null>(
    null,
  );
  const { data: dataProfile } = useGetProfileQuery();
  const isTetrika = dataProfile?.settings?.tetrika;
  const [isCreatedModalOpen, setIsCreatedModalOpen] = useState(false);
  const [showCopiedSuccess, setShowCopiedSuccess] = useState(false);
  const handleCloseCopiedSuccess = () => {
    setShowCopiedSuccess(false);
  };

  const { handleDownloadContract } = useDownloadContract({
    contractId: contractData?.id || null,
    contractNumber: contractData?.number || null,
    setIsLoadingDownloading,
  });

  const [active, setActive] = useState<string>('status');
  const [showNewContract, setShowNewContract] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [isWorkerHasContract, setIsWorkerHasContract] = useState<number>(0);
  const [referenceModalContent, setReferenceModalContent] = useState<{
    title: string;
    text: string;
  }>({ title: '', text: '' });

  const isMobile = useMediaQuery('(max-width: 768px)');

  const downloanHandle = CreateDownloadReferenceHandler(id);

  useEffect(() => {
    if (error) {
      navigate('/employees');
    }
  }, [error, navigate]);

  const handleDataFromChild = (newData: number) => {
    setIsWorkerHasContract(newData);
  };

  const content: Record<string, React.ReactNode> = {
    status: worker ? (
      <StatusProfileContent
        worker={worker}
        refetch={refetch}
        setIsCreatedModalOpen={setIsCreatedModalOpen}
      />
    ) : null,
    contracts: worker ? (
      <ContractsProfileContent
        workerId={worker.id}
        sendDataToParent={handleDataFromChild}
      />
    ) : null,
    references: (
      <ReferencesProfileContent
        worker={worker}
        onRefetchReady={(refetchFn) => setReferencesRefetch(() => refetchFn)}
      />
    ),
  };

  const isWorkerFnsStatus =
    (worker?.worker_app?.fns_status ?? -1) <= 0 || worker?.worker_app?.fns_status === 3;

  const isDisabledLoadReference = !isLoadingReference;

  if (isLoading) {
    return <LoadingSkeleton mt />;
  }

  return (
    <>
      <Helmet>
        <title>{getFullName(worker) || 'Исполнитель'}</title>
      </Helmet>
      <div className={styles.root}>
        <Link to='/employees' className={styles.link}>
          <BackBtn />
          Избранные исполнители
        </Link>

        <div className={styles.main}>
          <div className={styles.user}>
            <div className={styles.info}>
              <Avatar
                name={worker?.name || ''}
                surname={worker?.surname || ''}
                avatar={worker?.worker_app?.avatar ?? null}
                id={worker?.id}
                statusActive={''}
                height={isMobile ? '64px' : '80px'}
                width={isMobile ? '64px' : '80px'}
                isDeleted={worker?.is_deleted}
              />
              <div className={styles.text}>
                <div className={styles.textWrapper}>
                  <span className={styles.name}>
                    <TextWithTooltip
                      content={getFullName(worker)}
                      className={styles.name}
                    />
                  </span>

                  {getProblem(worker)}
                </div>
                <div className={styles.subWrapper}>
                  <div>
                    <span>{getFormatPhone(worker?.phone ?? '')}</span>
                    {worker?.inn && <span>ИНН {worker?.inn}</span>}
                  </div>
                  <div>
                    <span>
                      {worker?.worker_app?.nationality || 'Гражданство неизвестно'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.tabs}>
            <TabMenu
              lists={tabs}
              active={active}
              setActive={setActive}
              action={
                (active === 'contracts' &&
                  worker?.worker_app?.nationality !== 'Россия' && (
                    <Button
                      className={styles.createButton}
                      theme='filed'
                      onClick={() => {
                        if (!worker?.worker_app) {
                          setReferenceModalContent(
                            WORKER_PROFILE_MODAL_MESSAGES.NO_APP_CONTRACT,
                          );
                          setShowReferenceModal(true);
                        } else if (isWorkerFnsStatus) {
                          setReferenceModalContent(
                            WORKER_PROFILE_MODAL_MESSAGES.FNS_STATUS_CONTRACT,
                          );
                          setShowReferenceModal(true);
                        } else if (isTetrika && isWorkerHasContract > 1) {
                          setReferenceModalContent(
                            getErrorCreateContractMessage(isWorkerHasContract),
                          );
                          setShowReferenceModal(true);
                        } else if (!isTetrika && isWorkerHasContract) {
                          setReferenceModalContent(
                            getErrorCreateContractMessage(isWorkerHasContract),
                          );
                          setShowReferenceModal(true);
                        } else if (worker.is_in_stoplist) {
                          setReferenceModalContent(
                            WORKER_PROFILE_MODAL_MESSAGES.STOPLIST_CONTRACT,
                          );
                          setShowReferenceModal(true);
                        } else {
                          setShowNewContract(true);
                        }
                      }}>
                      <div>
                        Создать договор <IconPlus />
                      </div>
                    </Button>
                  )) ||
                (active === 'references' && (
                  <Button
                    className={styles.createButton}
                    theme='filed'
                    onClick={async () => {
                      if (worker?.worker_app === null) {
                        setReferenceModalContent(WORKER_PROFILE_MODAL_MESSAGES.NO_APP);
                        setShowReferenceModal(true);
                      } else if (
                        (worker?.worker_app?.fns_status ?? -1) <= 0 ||
                        worker?.worker_app?.fns_status === 3
                      ) {
                        setReferenceModalContent(
                          WORKER_PROFILE_MODAL_MESSAGES.FNS_STATUS,
                        );
                        setShowReferenceModal(true);
                      } else if (isDisabledLoadReference) {
                        setIsLoadingReference(true);
                        try {
                          await downloanHandle();
                          if (referencesRefetch) {
                            await referencesRefetch();
                          }
                        } catch (error: unknown) {
                          const errorMessage =
                            (error instanceof Error && error.message) ||
                            (typeof error === 'string' && error) ||
                            'Ошибка загрузки справки';
                          if (errorMessage === '500') {
                            setReferenceModalContent(
                              WORKER_PROFILE_MODAL_MESSAGES.ERROR_DOWNLOAD_REFERENCE,
                            );
                            setShowReferenceModal(true);
                          } else {
                            setReferenceModalContent({
                              title: 'Невозможно сформировать справку',
                              text: errorMessage,
                            });
                            setShowReferenceModal(true);
                          }
                        } finally {
                          setIsLoadingReference(false);
                        }
                      }
                    }}>
                    {isLoadingReference ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        Сформировать справку
                        <Loader size='xs' color='white' />
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        Сформировать справку
                        <DownloadWhite />
                      </div>
                    )}
                  </Button>
                ))
              }
            />

            <div className={styles.content}>{content[active]}</div>
          </div>
        </div>
      </div>
      {showNewContract && (
        <Modal setOpen={setShowNewContract} open={showNewContract}>
          <CreateContractForm
            onComplete={({ id, number }) => {
              setShowNewContract(false);
              setShowConfirmModal(true);
              refetch();
              setContractData({ id, number });
            }}
            defaultWorker={worker?.id}
            workerSurname={isTetrika ? worker?.surname : null}
          />
        </Modal>
      )}
      {showConfirmModal && (
        <ModalConfirm
          setShowLogoutModal={setShowConfirmModal}
          title='Договор создан'
          onConfirm={() => {
            setShowNewContract(false);
          }}
          text='Договор отправлен на подпись исполнителю в приложение'
          subText={
            <span
              className={styles.root_subText}
              onClick={() => {
                handleDownloadContract();
                setIsLoadingDownloading(true);
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Договор {contractData?.number}
                {isLoadingDownloading && <Loader size='xs' color='#002cfb' />}
              </div>
            </span>
          }
          cancelText='Готово'
        />
      )}
      {isCreatedModalOpen && (
        <CreateEmployedsСategory
          setIsShowFinishModal={setIsCreatedModalOpen}
          setShowCopiedSuccess={setShowCopiedSuccess}
        />
      )}
      {showCopiedSuccess && (
        <SuccessErrorInfo
          type='success'
          text='Создана новая категория'
          handleClose={handleCloseCopiedSuccess}
        />
      )}
      {showReferenceModal && (
        <ModalConfirm
          setShowLogoutModal={setShowReferenceModal}
          title={referenceModalContent.title}
          onConfirm={() => setShowReferenceModal(false)}
          text={referenceModalContent.text}
          cancelText='Закрыть'
        />
      )}
    </>
  );
};
